module.exports = "/assets/591830f33669a94a682d3152c84d3cdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/EI.png
// module id = 1337
// module chunks = 0